<template>
  <div class="video-wrap">
    <ezuikit-video :video="{src:value,title:name,appKey:appKey,appSecret:appSecret,cameraType:cameraType,cameraSerialNumber:cameraSerialNumber,channelNo:channelNo}"></ezuikit-video>
  </div>
</template>
<script>
import api from "@common/api/index.js";
import EzuikitVideo from "./EzuikitVideo";
export default {
  name: "videoView",
  // 引用组件
  components: { EzuikitVideo },
  props: {
    camera: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      value: '',
      name: '',
      appKey: '',
      appSecret: '',
      cameraType: '',
      cameraSerialNumber: '',
      channelNo: ''
    };
  },
  mounted () {
    this.init();
  },
  // 方法定义
  methods: {
    async init () {
      let res = await api.measure.getMeasureProperty(this.camera.id, "");
      if (!res.success) {
        this.$message.error(res.msg);
        return;
      }
      if (res.data.length !== 0) {
        let data = res.data;
        data.map(item => {
          if (item.name == "cameraEzvizUrl") {
            this.value = item.value;
            this.name = item.name;
          }
          if (item.name == "appKey") {
            this.appKey = item.value;
          }
          if (item.name == "appSecret") {
            this.appSecret = item.value;
          }
          if (item.name == "CameraType") {
            this.cameraType = item.value;
          }
          if (item.name == "CameraSerialNumber") {
            this.cameraSerialNumber = item.value;
          }
          if (item.name == "channelNo") {
            this.channelNo = item.value;
          }
        });
        /* this.value = res.data[0].value;
        this.name = res.data[0].name;
        const appKey = res.data.find((c) => c.name == "appKey");
        this.appKey = appKey ? appKey.value : "";
        const appSecret = res.data.find((c) => c.name == "appSecret");
        this.appSecret = appSecret ? appSecret.value : "";
        const cameraType = res.data.find((c) => c.name == "cameraType");
        this.cameraType = cameraType ? cameraType.value : "";
        const cameraSerialNumber = res.data.find((c) => c.name == "cameraSerialNumber");
        this.cameraSerialNumber = cameraSerialNumber ? cameraSerialNumber.value : "";
        const channelNo = res.data.find((c) => c.name == "channelNo");
        this.channelNo = channelNo ? channelNo.value : ""; */
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.video-wrap {
  width: 100%;
  height: 560px;
  box-sizing: border-box;
  overflow-y: auto;
}
</style>